/**
 * Determines if a given region requires patronymic input for participants
 * @param region The region to check
 * @returns true if the region requires patronymic, false otherwise
 */
export function requiresPatronymic(region: string): boolean {
    const patronymicRequiredRegions = ['RUSSIA', 'MOSCOW'];

    return patronymicRequiredRegions.includes(region);
}

/**
 * Validates patronymic data for a participant based on their venue's region
 * @param patronymic The patronymic value (optional string)
 * @param noPatronymic Boolean indicating if the participant doesn't have a patronymic
 * @param region The region to validate against
 * @returns true if the patronymic data is valid, false otherwise
 */
export function validatePatronymicData(
    patronymic: string | undefined,
    noPatronymic: boolean | undefined,
    region: string
): boolean {
    if (!requiresPatronymic(region)) {
        // For regions that don't require patronymic, any value is valid
        return true;
    }

    // For regions that require patronymic, either patronymic should be provided
    // or noPatronymic should be explicitly set to true
    if (noPatronymic === true) {
        return true;
    }

    return Boolean(patronymic && patronymic.trim().length > 0);
}
